<template>
    <div class="login-container">
        <div class="el-tabs">
            <div class="left" style="position:relative">
                <div class="leftCon">
                    <img style=" width: 60px; height: 60px; border-radius: 40px; position: absolute; top: 50px; left: 120px; "
                        src='../assets/img/jxsLogo.png' />
                    <h2 class="titles" style="font-size: 20px; font-weight: 600;">网云经销商</h2>
                    <div class="leftBotton" style="padding-top:40px;text-align:center;font-size:14px">
                        帮助线缆行业经销商实现购、销、存和应收应付一体管理</div>
                </div>
                <div class="imglog">
                    <img src='https://ncktc.obs.cn-south-1.myhuaweicloud.com/agt/res/login/weclome.png' />
                </div>
                <div style="position:absolute;bottom:0px;width:100%;box-sizing:border-box;padding:0px 50px 30px;">
                    <div class="otherWay" style="color:#57667e;margin-bottom:10px">
                        <i class="iconfonts icon-fengf" style="color:#57667e;"></i>
                        <!-- <span>登录系统</span> -->
                        <i class="iconfonts icon-fengf" style="color:#57667e;"></i>
                    </div>
                    <div style="display:flex;justify-content:space-between;">

                        <!-- <div 
                            class='leftLogo' @click="selectedSystem(item,i)"
                            v-for='(item,i) in imgUrlList' 
                            :style="{border:i==selectedIndex?'2px solid #57667e':'2px solid transparent'}" 
                            :key='i'>
                            <img :src="item.picurl">
                        </div> -->
                    </div>
                    <!-- logo特定大小删掉了，现在应该是一样大小的 -->
                </div>

            </div>
            <div class="right" style="position:relative">
                <div v-if="false"
                    style="width: 70px;height: 70px;position: absolute;top: 0px;background: #5d6d85;right: 0;">
                    <i class="iconfonts login-sm" :style="'font-size:70px;cursor: pointer;color:' + ssbgcolor"
                        v-if="whichLogin == 'phoneLogin'" @click="wxLogin"></i>
                    <i class="iconfonts login-zh" :style="'font-size:70px;cursor: pointer;color:' + ssbgcolor"
                        v-if="whichLogin != 'phoneLogin'" @click="phoneLogin"></i>
                    <div style="width: 0;height: 0;border-right: 85px solid transparent;border-bottom: 85px solid #5d6d85;position: absolute;top:0;right:0;cursor: pointer;"
                        v-if="whichLogin == 'phoneLogin'" @click="wxLogin"></div>
                    <div style="width: 0;height: 0;border-right: 85px solid transparent;border-bottom: 85px solid #5d6d85;position: absolute;top:0;right:0;cursor: pointer;"
                        v-if="whichLogin != 'phoneLogin'" @click="phoneLogin"></div>
                </div>
                <div class="titleReg" style="margin-top:20px">
                    <h2 class="title">{{ title }}</h2>
                    <!-- <div @click="reister" v-show="userRegShow">没有账号？注册</div> -->
                </div>
                <!-- <div class="company" v-show="companyShow">
                    <el-input type="text" v-model="company" placeholder="请点击按钮选择挂靠生产企业" disabled></el-input>
                    <el-button class="subBtn" @click="selectCompany">···</el-button>
                </div>
                <div class="company" v-show="companyShow">
                    <el-input type="text" v-model="dealer" placeholder="请点击按钮选择经销商" disabled></el-input>
                    <el-button class="subBtn" @click="selectDealer">···</el-button>
                </div>-->
                <div id='wxlogin' style="text-align: center; font-size: 14px; margin: 20px 0;"
                    v-show="whichLogin == 'wxLogin'">
                    <div
                        style="width:220px;height:220px;background:#fff;margin:30px auto;position: relative;border:5px solid #fff;">
                        <div id="qrcode" ref="qrcode"></div>
                        <div
                            style="background:#fff;position: absolute;width:50px;height:50px;left:85px;top:85px;border-radius:25px">
                            <img style=" width: 40px; height: 40px;border-radius:20px;margin:5px"
                                src='https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/agt/res/login/wxlogin.png?AccessKeyId=QTEZALFEWXYLBIPF1ZXH&Expires=1668132043&Signature=XzLyozofQ1i7IuIVs9EISwAcZQA%3D' />
                        </div>
                    </div>
                    <div style="color:#ccc">使用<span :style="'padding:10px 0;color:' + ssbgcolor">微信扫一扫</span>授权登陆</div>
                </div>
                <div class="user" v-show="phoneShow && whichLogin != 'wxLogin'">
                    <el-input type="text" v-model="userPhone" placeholder="手机号" maxlength="11" size="small"
                        prefix-icon='el-icon-mobile-phone'></el-input>
                </div>
                <!-- <div style="width:220px;height:220px"  v-show="whichLogin == 'wxLogin'">
                    <img src="" alt="pic" >
                </div> -->

                <div class="user" v-show="captchaShow && whichLogin != 'wxLogin'">
                    <el-input type="text" v-model="userCaptcha" placeholder="验证码" style="width:215px"
                        prefix-icon='iconfonts el-yanzhegnma yzm' size="small"></el-input>
                    <el-button v-if="isSend == true" type="primary" class="captcheBtn" disabled>({{ capBtn
                        }}s)后可发送</el-button>
                    <el-button v-if="isSend == false" type="primary" class="captcheBtn"
                        @click="getCaptcha">发送验证码</el-button>
                </div>
                <div class="user" v-show="userShow && whichLogin != 'wxLogin'">
                    <el-input type="text" v-model="user" placeholder="账号" prefix-icon='el-icon-user'
                        size="small"></el-input>
                </div>
                <div class="user" v-show="uerPwdShow && whichLogin != 'wxLogin'">
                    <el-input type="password" @keyup.enter.native="verify" v-model="userPwd" placeholder="请输入密码"
                        prefix-icon='el-icon-lock' size="small"></el-input>
                </div>
                <div class="user" v-show="newUserPwdShow && whichLogin != 'wxLogin'">
                    <el-input type="password" v-model="newUserPwd" placeholder="新密码"></el-input>
                </div>
                <div class="footer" v-show="aboutPwdShow && whichLogin != 'wxLogin'">
                    <div>
                        <el-checkbox v-model="checkState" :checked="checkState" class="pointerStle"></el-checkbox> 记住密码
                    </div>
                    <div @click="forgetPwd" class="pointerStle">忘记密码？</div>
                </div>
                <el-button class="subBtn" @click="verify" v-show="whichLogin != 'wxLogin'"
                    :style="'background-color:' + ssbgcolor">{{ btnText }}</el-button>
                <!-- <div v-show="userRegShow" style="display: flex;justify-content: space-between;margin: 20px 0;color: #ccc;width: 200px; margin: 0 auto;">
                    <div @click="logintest" style="cursor: pointer;">体验一下</div>
                    <div>|</div>
                    <div @click="reister" :style="'cursor: pointer;color:'+ssbgcolor">立即注册</div>
                </div> -->
                <!-- 选择企业 -->
                <el-dialog title="请选择企业" class="select-platform" style="width:70%" :visible.sync="outerVisible"
                    v-dialogDrag v-if="false">
                    <div slot="footer" class="dialog-footer">
                        <el-cascader-panel :options="sort_company" v-model="selectedCompany"
                            style="width:100%"></el-cascader-panel>
                        <div class="selectBtn">
                            <el-button @click="outerVisible = false">取 消</el-button>
                            <el-button type="primary" @click="confirmConpany">确定</el-button>
                        </div>
                    </div>
                </el-dialog>
                <!-- 选择经销商 -->
                <el-dialog title="请选择经销商" class="select-platform" style="width:50%" :visible.sync="outerDealerVisible"
                    v-dialogDrag v-if="false">
                    <div slot="footer" class="dialog-footer dealer">
                        <el-input placeholder="请输入内容" v-model="dealerSearch" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                        <el-cascader-panel :options="DealerOptions" v-model="selectedDealer"
                            style="width:100%"></el-cascader-panel>
                        <div class="selectBtn">
                            <el-button @click="outerDealerVisible = false">取 消</el-button>
                            <el-button type="primary" @click="confirmDealer">确定</el-button>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import QRCode from 'qrcode2'
import { dateChange } from '../assets/unit/util';
import ObsClient from "../../dist/esdk-obs-browserjs-without-polyfill-3.19.5.min.js";
var obsClient;
export default {
    components: { QRCode },
    name: "Login",
    props: ["selectedModule"] /**selectedModule:传给模块树的模块标识值 */,
    data() {
        return {
            ssbgcolor: this.$Store.state.bgcolor,
            scokettoken: '',
            scoketid: '',
            qrcode: '',
            ws: null,
            isDestroyed: false, // 页面是否销毁
            lockReconnect: false, // 是否真正建立连接
            timeout: 5000, // 3秒一次心跳
            timeoutObj: null, // 心跳心跳倒计时
            serverTimeoutObj: null, // 心跳倒计时
            timeoutnum: null, // 断开 重连倒计时  
            system: 'agt',
            selectedIndex: 0,
            imgUrlList: [
                { url: '/src/assets/img/nca.png', },
            ],
            imgUrl: "/src/assets/img/navback.png",
            dealer: "" /**经销商的搜索 */,
            dealerSearch: "" /**经销商的搜索框内容 */,
            DealerOptions: [] /**经销商的列表 */,
            selectedDealer: "" /**选择的经销商 */,
            outerDealerVisible: false /**经销商 */,
            selectedCompany: "" /**选择的企业 */,
            /**企业面板 */
            outerVisible: false,
            /**企业 */
            companyOptions: [],
            /**区域 */
            areaOptions: [],
            /**记住密码 */
            checkState: false,
            time: "",
            isSend: false,
            capBtn: "",
            newUserPwd: "",
            /**唯一标识，登录页面状态 */
            whichLogin: "phoneLogin",
            leftTile: "网云技术ERP后台管理系统",
            leftContent: "开发中...",
            btnText: "登录",
            company: "",
            user: "" /**账号 */,
            userPwd: "" /**密码 */,
            title: "手机号+密码登录 ",
            userPhone: "" /**手机号码 */,
            userCaptcha: "",
            /**显示 */
            newUserPwdShow: false,
            companyShow: false /**企业 */,
            userShow: false /**账号 */,
            uerPwdShow: true /**密码 */,
            phoneShow: true /**手机号码 */,
            captchaShow: false /**验证码 */,
            aboutPwdShow: true /**记住密码，忘记密码 */,
            userRegShow: false /**注册 */,
            /**提示文字 */
            textCompany: "请选择企业",
            textPhone: "请正确填写手机号码",
            textUserPwd: "请填写6位以上的密码",
            textUserCaptcha: "请填写正确的验证码",
        };
    },
    watch: {
        watch: {
            userPhone(n) {
                this.userPhone = n.replace(/\D/g, '');
            },
        },
    },
    created() {
        /**存储企业 */
        if (localStorage.hasOwnProperty("agtcompany")) {
            this.company = localStorage.getItem("agtcompany");
        }
        if (localStorage.hasOwnProperty('agtpwdCheckState') && localStorage.getItem('agtpwdCheckState') == 'true') {
            this.checkState = true;
            if (localStorage.hasOwnProperty("agtuserPhone")) {
                this.userPhone = localStorage.getItem("agtuserPhone")
            }
            if (localStorage.hasOwnProperty('agtuserPwd')) {
                this.userPwd = localStorage.getItem("agtuserPwd")
            }
        }
        if (this.selectCompany.length < 1) {
            this.selectedDealer = [];
            this.dealer = "";
        }
    },
    mounted() {
        obsClient = new ObsClient({
            access_key_id: "QTEZALFEWXYLBIPF1ZXH",
            secret_access_key: "hgh3XEUxF0bqt2Klu9DNbnG9goAdj2HqoHFL8RfK",
            server: "https://obs.cn-south-1.myhuaweicloud.com",
        });
        this.log(obsClient);
        // 初始化websocket
        // this.initWebSocket() 
    },
    // 页面销毁
    beforeDestroy() {
        this.isDestroyed = true
        this.timeoutnum && clearTimeout(this.timeoutnum)
        this.timeoutObj && clearTimeout(this.timeoutObj)
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj)
        // this.ws.close() // 关闭ws
    },
    head: {
        script: [
            { src: "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js" }
        ]
    },
    // },
    computed: {
        /**企业排序 */
        sort_company() {
            return this.sortByKey(this.companyOptions, "findex");
        }
    },
    methods: {
        getsocketid() {
            this.$axios.post("vx/scan/login", { system: 'agt', visit: 'web' }).then(({ data }) => {
                if (data.code == 0) {
                    this.log(data.data)
                    this.qrcode = data.data.qrcode
                    this.scoketid = data.data.id
                    this.scokettoken = data.data.token
                    let qrcode = new QRCode('qrcode', {
                        width: 220,  // 二维码宽度 
                        height: 220, // 二维码高度
                        text: data.data.qrcode
                    })
                    let obj = {
                        scokettoken: this.scokettoken,
                        scoketid: this.scoketid
                    }
                    this.$emit('wxlogin', obj)
                } else {
                    this.$alert(data.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                }
            })
        },
        initWebSocket() {
            const _this = this
            // 判断页面有没有存在websocket连接
            if (window.WebSocket) {
                _this.ws = new WebSocket('wss://app.ncerp.cn:9611/ws/system')
                _this.ws.onopen = function (e) {
                    _this.log('服务器连接成功')
                    _this.start() // 开启心跳
                }
                _this.ws.onclose = function (e) {
                    _this.log('服务器连接关闭')
                    _this.reconnect() // 重连
                }
                _this.ws.onerror = function (e) {
                    _this.log('服务器连接出错')
                    _this.reconnect() // 重连
                }
                _this.ws.onmessage = function (e) {
                    _this.log('onmessage', JSON.parse(e.data))
                    _this.reset() // 心跳重置
                    // 接收服务器返回的数据
                    let resData = JSON.parse(e.data)
                    if (resData.cmd == 'ping') { // 心跳消息
                        _this.log('ping')
                        return
                    }
                    if (resData.cmd == 'vxscanlogin') { // 心跳消息
                        _this.log('vxscanlogin', resData)
                        localStorage.setItem("agtlogintime", dateChange('dateTime', new Date()));
                        localStorage.setItem('agtuserinfo', JSON.stringify(resData.object.data))
                        localStorage.setItem('agttoken', resData.object.data.ftoken)
                        localStorage.setItem("agtcompany", resData.object.data.fconfig.link.agt.linkname);
                        this.$router.push("/home");
                    }
                    // 业务消息
                }
            }
        },
        // 重新连接
        reconnect() {
            var self = this
            if (self.lockReconnect || self.isDestroyed) {
                return
            }
            self.log('重新连接。。。')
            self.lockReconnect = true
            // 没连接上会一直重连，设置延迟避免请求过多
            self.timeoutnum && clearTimeout(self.timeoutnum)
            self.timeoutnum = setTimeout(function () {
                // 新连接
                // self.initWebSocket()
                self.lockReconnect = false
            }, 4000)
        },
        // 重置心跳
        reset() {
            var self = this
            // 清除时间
            self.timeoutObj && clearTimeout(self.timeoutObj)
            self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj)
            // 重启心
            self.start()
        },
        vxlogin() {
            let ojb_params = {
                "cmd": "vxscanlogin",
                "sub": "connect",
                "token": this.scokettoken,
                "id": this.scoketid,
                "owner": {
                    "userid": -1,
                    "linkid": -1,
                    "teamid": -1,
                    "system": "erp",
                    "visit": "web",
                    "naviid": -1,
                    "pageid": -1,
                    "dataid": -1,
                    "bodyid": -1,
                },
                "data": "",
                "sendto": null,
                "object": null,
                "array": null
            }

            this.ws.send(JSON.stringify(ojb_params))
        },
        // 开启心跳
        start() {
            let self = this
            self.timeoutObj && clearTimeout(self.timeoutObj)
            self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj)
            self.timeoutObj = setTimeout(function () {
                self.log(self.ws.readyState)
                // 这里发送一个心跳，后端收到后，返回一个心跳消息
                if (self.ws.readyState === 1) { // 判断连接是否正常
                    let ojb_params = {
                        "cmd": "ping",
                        "sub": "",
                        "token": self.scokettoken,
                        "id": self.scoketid,
                        "owner": {
                            "userid": -1,
                            "linkid": -1,
                            "teamid": -1,
                            "system": "erp",
                            "visit": "web",
                            "naviid": -1,
                            "pageid": -1,
                            "dataid": -1,
                            "bodyid": -1,
                        },
                        "data": "",
                        "sendto": null,
                        "object": null,
                        "array": null
                    }

                    self.ws.send(JSON.stringify(ojb_params))
                } else { // 否则重连
                    self.reconnect()
                }
                self.serverTimeoutObj = setTimeout(function () {
                    self.log('1111111', 430)
                    self.ws.close() // 超过3秒没收到心跳消息关闭重连
                }, self.timeout)
            }, self.timeout)
        },
        // },
        logintest() {
            this.userPhone = '13332993762'
            this.userPwd = '654321'
            this.whichLogin = 'phoneLogin'
            this.login()
        },
        wxLogin() {
            this.whichLogin = "wxLogin";
            this.btnText = "登录";
            this.title = "微信登录";
            if (this.scoketid == '') {
                this.getsocketid()
            }
        },
        /**选择系统 */
        selectedSystem(item, i) {
            this.selectedIndex = i;
            this.leftContent = item.remark;
            this.leftTile = item.title;
            /**将登录选择的系统存起来 */
            localStorage.setItem('agtsystem', item.system);
            localStorage.setItem('agtsystemImg', item.picurl);
            // 'agt' = item.system;
            // switch ('agt') {
            //   case 'erp':
            //      document.title = '网云ERP系统'
            //     break;
            //   case 'agt':
            //      document.title = '网云经销商系统'
            //     break;
            //   case 'ncx':
            //      document.title = '网云业务助手'
            //     break;
            //   case 'ncv':
            //      document.title = '网云防伪溯源系统'
            //     break;
            //   default:
            //     break;
            // }
            document.title = '网云经销商系统'
        },
        /**排序 */
        sortByKey(array, key) {
            return array.sort(function (a, b) {
                var x = a[key];
                var y = b[key];
                return x < y ? -1 : x > y ? 1 : 0;
            });
        },
        /**确认经销商 */
        confirmDealer() {
            this.outerDealerVisible = false;
        },
        /**经销商点击按钮事件 */
        selectDealer() {
            this.outerDealerVisible = true;
        },
        /**确认企业 */
        confirmConpany() {
            if (this.selectedCompany.length < 1) {
                this.$message.error("请选择企业");
                return;
            }
            if (this.selectedCompany.length == 2) {
                this.company = this.selectedCompany[1];
            } else {
                this.company = this.selectedCompany[0];
            }
            this.outerVisible = false;
        },
        /**企业点击按钮事件 */
        selectCompany() {
            this.outerVisible = true;
        },
        /**注册 */
        reister() {
            this.whichLogin = "userReg";
            this.userShow = true;
            this.uerPwd = true;
            this.uerPwdShow = true;
            this.captchaShow = true;
            this.phoneShow = true;
            this.companyShow = true;
            this.title = "注册";
            this.btnText = "注册";
            this.aboutPwdShow = false;
            this.newUserPwdShow = false;
            this.userRegShow = false;
        },
        /**账号密码登录 */
        userLogin() {
            this.whichLogin = "userLogin";
            this.companyShow = false;
            this.userShow = true;
            this.uerPwd = true;
            this.uerPwdShow = true;
            this.aboutPwdShow = true;
            this.userRegShow = false;
            this.captchaShow = false;
            this.phoneShow = false;
            this.title = "账号密码登录";
            this.btnText = "登录";
            this.newUserPwdShow = false;
        },
        /**验证码登录 */
        captchaLogin() {
            this.whichLogin = "captchaLogin";
            this.companyShow = false;
            this.uerPwdShow = false;
            this.userShow = false;
            this.uerPwd = false;
            this.aboutPwdShow = false;
            this.userRegShow = false;
            this.captchaShow = true;
            this.phoneShow = true;
            this.newUserPwdShow = false;
            this.btnText = "登录";
            this.title = "手机验证登录";
        },
        /**手机号密码登录 */
        phoneLogin() {
            this.whichLogin = "phoneLogin";
            this.captchaShow = false;
            this.companyShow = false;
            this.userShow = false;
            this.uerPwd = false;
            this.aboutPwdShow = true;
            this.newUserPwdShow = false;
            this.userRegShow = false;
            this.uerPwdShow = true;
            this.phoneShow = true;
            this.btnText = "登录";
            this.title = "手机号+密码登录";
        },
        loginMethod(params) {
            this.$axios.post("user/login", params).then(({ data }) => {
                if (data.code == 0) {
                    this.$message.success("登录成功");
                    localStorage.setItem("agttoken", data.data.ftoken);
                    localStorage.setItem("agtcompany", data.data.fconfig.link.agt.linkname);
                    localStorage.setItem('agtuserinfo', JSON.stringify(data.data));
                    localStorage.setItem("agtlogintime", dateChange('dateTime', new Date()));
                    this.getImg(data.data)
                    this.getuserid(data.data.fmobile);
                    this.$router.push("/home");
                } else {
                    this.$alert(data.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                }
            })
        },
        // 获取部门员工内码
        getuserid(mobile) {
            const flinkid = JSON.parse(localStorage.getItem("agtuserinfo")).flinkid;
            const gocid = JSON.parse(localStorage.getItem("agtuserinfo")).fgocid ?
                JSON.parse(localStorage.getItem("agtuserinfo")).fgocid :
                JSON.parse(localStorage.getItem("agtuserinfo")).fcorp.gocid;
            const obj = {
                system: "agt",
                douserid: mobile,
                visit: "web",
                linkid: flinkid,
                gocid: gocid
            }
            axios.post('user/empid/find', obj).then(res => {
                if (res.data.code == '0') {
                    if (res.data.data) {
                        localStorage.setItem("depEmployee", JSON.stringify(res.data.data))
                    }
                }
            });
        },
        getImg(arr) {
            if (arr.ffile) {
                arr.ffile.forEach(el => {
                    if (el.keyword == 'head') {
                        this.log('’205', el.data.length - 1)
                        this.getInfoImg1(el.data[el.data.length - 1])
                    }
                })
            }
        },
        getInfoImg1(obj) {
            let self = this
            let fileName = obj.path + obj.file + obj.type;
            obsClient.getObject(
                {
                    Bucket: 'ncktc',
                    Key: fileName,
                    SaveByType: "file",
                },
                function (err, result) {
                    self.log('221', err, result)
                    if (err) {
                        self.log("Error-->" + err);
                    } else {
                        self.log('225', result)
                        localStorage.setItem('agtuserImg', result.InterfaceResult.Content.SignedUrl); // 用户头像
                    }
                })
        },
        /**忘记密码 */
        forgetPwd() {
            this.whichLogin = "forgetPwd";
            this.companyShow = false;
            this.uerPwdShow = false;
            this.userShow = false;
            this.uerPwd = false;
            this.aboutPwdShow = false;
            this.userRegShow = false;
            this.newUserPwdShow = true;
            this.captchaShow = true;
            this.phoneShow = true;
            this.title = "找回密码";
            this.btnText = "确认";
        },
        login() {
            this.remenberPwd();
            localStorage.setItem("agtuserPhone", this.userPhone);
            /**企业经销商密码登录 */
            if (this.whichLogin == "userLogin") {
                this.loginMethod({
                    username: this.user,
                    userpass: this.userPwd,
                    visit: 'web',
                    system: 'agt'
                })
            }
            if (this.whichLogin == "captchaLogin") {
                // this.verify();
                /**验证码登录 */
                this.loginMethod({
                    mobile: this.userPhone,
                    captcha: this.userCaptcha,
                    visit: 'web',
                    system: 'agt'
                })
            }
            if (this.whichLogin == "phoneLogin") {
                /**手机号密码登录 */
                this.loginMethod({
                    mobile: this.userPhone,
                    userpass: this.userPwd,
                    visit: 'web',
                    system: 'agt'
                })
            }
            if (this.whichLogin == "forgetPwd") {
                /**忘记密码 */
                this.$axios.post("user/pass/save", {
                    captcha: this.userCaptcha,
                    newpass: this.newUserPwd,
                    mobile: this.userPhone,
                    visit: 'web',
                    system: 'agt'
                })
                    .then(res => {
                        if (res.data) {
                            if (res.data.code === 0) {
                                this.$message({
                                    message: "修改成功，请使用新密码登录",
                                    type: "success"
                                });
                            } else {
                                this.$alert(res.data.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                            }
                        }
                    });
            }
            if (this.whichLogin == 'userReg') {
                if (!this.userPwd) {
                    this.$message.error('请输入密码')
                    return;
                }
                axios.post('user/reg', {
                    mobile: this.userPhone,
                    nickname: this.user,
                    captcha: this.userCaptcha,
                    userpass: this.userPwd,
                    visit: 'web',
                    system: 'agt'
                }).then(res => {
                    if (res.data.code == '0') {
                        this.$message({
                            message: '注册成功!',
                            type: 'success'
                        })
                        this.creatBoss(this.userPhone);
                    } else {
                        this.$alert(res.data.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                    }
                }).catch(re => {
                    this.$alert(re.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                })
            }
        },
        creatBoss(e) {
            let data = {
                "linkid": -1,
                "visit": "web",
                "system": "agt",//可传erp,ktcbiz,ncx,ncv,nco,shop,ktcjxc,ktcfin,ktcbiz,ktcbiz,ktcoa
                "domobile": e,//申请人的手机号
                "douserid": -1,//申请人的用户内码，如果传了手机号，这里传-1即可
                "data": {}
            }
            this.$axios.post("boss/create", data).then(({ data }) => {
                if (data.code == 0) {
                    localStorage.setItem('agtbosslinkid', data.data.linkid)
                    let data1 = {
                        username: this.userPhone,
                        userpass: this.userPwd,
                        visit: 'web',
                        system: 'agt'
                    }
                    this.$axios.post("user/login", data1).then(({ data }) => {
                        if (data.code == 0) {
                            this.$message.success("登录成功");
                            localStorage.setItem("agttoken", data.data.ftoken);
                            localStorage.setItem("agtlogintime", dateChange('dateTime', new Date()));
                            localStorage.setItem('agtuserinfo', JSON.stringify(data.data));
                            this.$router.push("/home");

                        } else {
                            this.$alert(data.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                        }
                    })
                    // this.log(data.data.linkid)
                } else {
                    this.$alert(data.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                }
            })
        },
        creatBoss1() {
            let data = {
                "linkid": -1,
                "visit": "web",
                "system": "agt",//可传erp,ktcbiz,ncx,ncv,nco,shop,ktcjxc,ktcfin,ktcbiz,ktcbiz,ktcoa
                "domobile": 15389046277,//申请人的手机号
                "douserid": -1,//申请人的用户内码，如果传了手机号，这里传-1即可
                "data": {}
            }
            this.$axios.post("boss/create", data).then(({ data }) => {
                if (data.code == 0) {
                    localStorage.setItem('agtbosslinkid', data.data.linkid)
                    // this.log(data.data.linkid)
                } else {
                    this.$alert(data.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                }
            })
        },
        getCaptcha() {
            /**获取验证码 */
            axios
                .post("https://www.ncerp.cn/erp/user/auth/sms", {
                    mobile: this.userPhone,
                    visit: 'web',
                    system: 'agt',
                    usage: ""
                })
                .then(res => {
                    if (res.data) {
                        if (res.data.code === 0) {
                            this.$message({
                                message: "发送成功，请注意查收！",
                                type: "success"
                            });
                            this.isSend = true;
                            this.capBtn = 60;
                            setInterval(() => {
                                if (this.capBtn > 1) {
                                    this.capBtn--;
                                } else {
                                    this.isSend = false;
                                }
                            }, 1000);
                        } else {
                            this.$alert(res.data.message, "错误提示", { confirmButtonText: '确定', type: "error" });
                        }
                    }
                });
        },
        // 确认登录
        verify() {
            /**文本框输入验证 */
            let CompanyLength = this.company.length;
            let userPhoneLength = this.userPhone.length;
            let userPwdLength = this.userPwd.length;
            let userCaptchaLength = this.userCaptcha.length;
            let whichLogin = this.whichLogin;

            if (whichLogin == "userLogin") {
                if (!this.user) {
                    this.$message.error('请输入账号!')
                    return
                } else if (!this.userPwd) {
                    this.$message.error('请输入密码!')
                    return
                } else {
                    this.login()
                }
            } else if (
                whichLogin == "captchaLogin" ||
                whichLogin == "forgetPwd"
            ) {
                if (userPhoneLength != 11) {
                    this.$message.error(this.textPhone);
                } else

                    if (userCaptchaLength < 4) {
                        this.$message.error(this.textUserCaptcha);
                    }
                    else {
                        this.login()
                    }
            } else if (whichLogin == "phoneLogin") {
                if (userPhoneLength != 11) {
                    this.$message.error(this.textPhone);
                } else {
                    this.login()
                }
            } else if (whichLogin == "userReg") {
                if (userPhoneLength != 11) {
                    this.$message.error(this.textPhone);
                    return;
                } else
                    if (userCaptchaLength < 1) {
                        this.$message.error(this.textUserCaptcha);
                        return;
                    } else {
                        this.login()
                    }
            }

        },
        remenberPwd() {
            /**记住密码 */
            if (!this.checkState) {
                /**不记住密码 */
                if (
                    this.whichLogin == "phoneLogin" ||
                    this.whichLogin == "userLogin"
                ) {
                    /**手机密码登录 */
                    if (localStorage.hasOwnProperty("agtuserPwd")) {
                        /**如果有密码就删掉 */
                        localStorage.removeItem("agtuserPwd");
                    }
                    if (localStorage.hasOwnProperty("agtuserPhone")) {
                        /**不记住密码，如果缓存有就删掉 */
                        localStorage.removeItem("agtuserPhone");
                    }
                    if (localStorage.hasOwnProperty('agtpwdCheckState')) {
                        localStorage.removeItem("agtpwdCheckState")
                    }
                }
            } else {
                /**记住密码 */
                localStorage.setItem("agtuserPwd", this.userPwd);
                /**手机密码登录 */
                localStorage.setItem('agtpwdCheckState', this.checkState)
            }
        },
        /**获取区域 */
        getCompany() {
            axios.get("boss/group?visit=web&system=" + 'agt').then(res => {
                if (res.data.code === 0) {
                    let area = [];
                    res.data.data.forEach(element => {
                        let obj = {};
                        obj.label = element.fname;
                        obj.value = element.fname;
                        obj.fgroupid = element.fgroupid;
                        axios
                            .get("boss/erp?groupid=" + element.fgroupid + '&visit=web&system=' + 'agt')
                            .then(res => {
                                let arr = [];
                                let child = res.data.data;
                                if (child && child.length > 0) {
                                    child.forEach(el => {
                                        let childObj = {};
                                        childObj.label = el.fname;
                                        childObj.value = el.fname;
                                        arr.push(childObj);
                                    });
                                    obj.children = arr;
                                }
                                area.push(obj);
                            });
                    });
                    this.companyOptions = area;
                }
            });
        }
    }
};
</script>

<style lang="scss">
@import "./loginPub";
</style>


// WEBPACK FOOTER //
// src/views/login.vue